import { render, staticRenderFns } from "./professionalOrderSideView.vue?vue&type=template&id=06b08deb"
import script from "./professionalOrderSideView.vue?vue&type=script&lang=js"
export * from "./professionalOrderSideView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports